<template>
<div style="position: relative; width: 100%; height: 100%; pointer-events: none;">
  <transition name="fade">
    <div class="scs-screen" v-show="!screenSharingHidden" style="pointer-events: all;">
      <div class="scs-container">

        <!-- Moderator -->
        <div v-if="localUserIsModerator()" style="width: 100%; height: 100%">
          <span class="scs-name-badge">
            <span v-if="localUserIsModerator()" class="scs-moderator-title">Moderator: </span>
            <span>{{localUserName}}</span>
          </span>
          <div class="scs-video" id="video-session"></div>
          <FluxComPublisher screencast :opts="publishingProperties" where="video-session"/>
        </div>

        <!-- Visitor -->
        <div v-for="stream in videoStreams" :key="stream.streamId" style="width: 100%; height: 100%">
          <span class="scs-name-badge">
            <span v-if="isUserWithIDModerator(stream.connection.data.user_id)" class="scs-moderator-title">Moderator: </span>
            <span>{{getUserName(stream.connection.data.user_id)}}</span>
          </span>
          <FluxComSubscriber :stream="stream" :opts="videoProperties(stream.connection.data.user_id, stream)"/>
        </div>  

      </div>  
      
    </div>
  </transition> 
  <!-- <md-button v-if="localUserIsModerator()" :md-ripple="false" @click="togglePanel" class="md-icon-button enabelPointer" style="z-index: 10; position: absolute; bottom: 3%; right: 42%; background: orange; width: 250px">
    <span v-show="screenSharingHidden">{{ $t('Screen Sharing Fenster anzeigen') }}</span> 
    <span v-show="!screenSharingHidden">{{ $t('Screen Sharing Fenster ausblenden') }}</span>
	</md-button> -->
</div>
</template>

<style>
  .scs-screen {
    position: relative;
    width: 100%;
    height: 100%;
    background: #000000e3;
  }

  .scs-container {
    z-index: 1;
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    padding: 20px;
    padding-top: 15px;
    width: 90%;
    height: 83%;
  }

  .scs-moderator-title {
    color: var(--primaryColor);
  }

  .scs-name-badge{
    font-size: 20px;
  }

  .scs-container .OT_root{
    margin-top: 10px;
    width: 100% !important;
    height: 95% !important;
    background-color: transparent !important;
  }

  .scs-container .OT_widget-container{
    background-color: transparent;
  }

  .scs-container .md-icon-button{
    width: 100px;
    margin: auto;
  }

  .scs-hidden{
    display: none;
  }

  .md-icon-button {
    border-radius: 3px;
    background-color: #2D2D2FD0;
    padding-left: 10px;
    padding-right: 10px;
    width: 60px;
  }

  .md-icon-button .md-ripple {
    border-radius: 3px;
  }
</style>
    
<script>
import {mapGetters, mapState, mapMutations} from 'vuex';

export default {
    components: {},
    name: 'screensharingpanel',
	data: () => ({
    videoPropertyDefault: {
      fitMode: 'contain',
      insertDefaultUI: true,
      resolution: '320x240',
      showControls: true,
      audioLevelDisplayMode: 'auto',
      buttonDisplayMode: 'auto',
      nameDisplayMode: 'off',
		},
    screenSharingHidden: false,     
	}),
	computed: {
		...mapState({
			isAdjustingSettings: (state) => state.session.isAdjustingSettings,
			isOnboardingComplete: (state) => state.session.isOnboardingComplete,
			openTokStreams: (state) => state.session.openTokStreams,
		}),
		...mapGetters(['isVideoConnected', 'localUser', 'users', 'localUserID']),
		localUserName () {
			return this.localUser.getName();
		},
		videoStreams() {
			return this.openTokStreams.filter( x => x.videoType === 'screen' );
    },
    publishingProperties() {
      return {
        width: window.screen.width * 0.6,
        height: window.screen.height * 0.6,
        maxResolution: { width: 1920, height: 1080 },
        frameRate: 30,
      };
    }
  },
	methods: {
    ...mapMutations(["setDialogueOpen"]),
		isUserWithIDModerator (userID) {
			let user = this.users.filter(x => x.getID() === userID);
			if (user.length > 0) {
				return user[0].getRole() === 'moderator';
			}
			return false;
		},
		getUserName (userID) {
			let user = this.users.filter(x => x.getID() === userID);
			if (user.length > 0) {
				return user[0].getName();
			}
			return "";
		},
		localUserIsModerator () {
			if (this.localUser && this.localUser.getRole() === "moderator")
				return true;
			return false;
		},
		videoProperties (id, stream) {
			let vp = {...this.videoPropertyDefault};
			// if id is not set, return properties of the local user
            let userID = id ? id : this.localUserID;
            
			if (stream.videoDimensions) {
				vp.width = Math.min( stream.videoDimensions.width, window.screen.width * 0.6 );
				vp.height = Math.min( stream.videoDimensions.height, window.screen.height * 0.6 );
			}
			//console.log("Video properties for user " + id + " => " + JSON.stringify(vp));
			return vp;
		},
    togglePanel(){
      this.screenSharingHidden =!this.screenSharingHidden;
			this.setDialogueOpen(!this.screenSharingHidden);	     
    }       
  },
}
</script>
